import { gql } from '@apollo/client';

export const GET_FEATURE_LIMITS_GLOBAL = gql`
  query GetFeatureLimitsGlobal {
    featureLimitsGlobal {
      id
      featureKey
      userId
      monthlyLimit
      updatedAt
    }
  }
`;

export const GET_USER_FEATURE_LIMITS_LIST = gql`
  query GetUserFeatureLimitsList($input: UserFeatureLimitsListInput!) {
    userFeatureLimitsList(input: $input) {
      entities {
        userId
        userName
        userEmail
        updatedAt
        overrides {
          featureKey
          monthlyLimit
          kind
        }
      }
      total
      offset
      limit
    }
  }
`;

export const GET_USER_FEATURE_LIMITS = gql`
  query GetUserFeatureLimits($userId: ID!) {
    userFeatureLimits(userId: $userId) {
      featureKey
      kind
      monthlyLimit
      used
      remaining
      source
    }
  }
`;
